














































































import { Vue, Component, Prop } from 'vue-property-decorator';
import ContractGroupFilterBind from '@/domain/contract/entity/contract-group-filter-bind.entity';
import EnumObject from '@/domain/enum-object.entity';
import MainButton from '@/shared/buttons/main-button.component.vue';

@Component({
  components: {
    MainButton,
  },
})
export default class ContractGroupFilterBindComponent extends Vue {
  @Prop({ required: true })
  filter!: ContractGroupFilterBind;

  ref: any = this.$refs;

  statusOptions: { value: string; description: string }[] = [
    { value: 'ACTIVE', description: 'Ativo' },
    { value: 'INACTIVE', description: 'Inativo' },
    { value: 'CANCELED', description: 'Cancelado' },
  ];

  contractStatus: Array<EnumObject> = EnumObject.ofList(this.statusOptions);

  clear() {
    this.ref.form.reset();
    this.filter = ContractGroupFilterBind.of({});
    this.send()
  }

  send() {
    this.$emit('filter', this.filter);
  }
}
